<template>
  <div class="subModal scroll">
    <form @submit.prevent="postForm()">
      <button>Salvar</button>
      <div class="">
        <label v-for="(b, i) in badges" :key="i">
          <input type="checkbox" @click="addBadge(b.id, $event)" hidden>
          <div class="badge tip" :class="{'active': BadgeSel.find((e) => e === b.id)}"
               :style="{backgroundImage: 'url('+b.image+')'}">
          </div>
        </label>
      </div>
    </form>
  </div>
</template>

<script setup>


import { ref } from 'vue'
import { callAction, uploadUrl } from '@/services/api.js'
import { useStore } from '@/stores/index.js'

const emits = defineEmits(['close', 'reload', 'textAlerta'])
const store = useStore()

const badges = ref([])
const BadgeSel = ref([])


async function postForm() {
  try {
    const data = await callAction('set_profile_badges', { badge_ids: BadgeSel.value })
    if (data.error) {
      emits('textAlerta', data.text ?? 'Erro ao salvar emblemas')
      return
    }
    emits('textAlerta', data.message ?? 'Emblemas atualizados!')
  } catch (e) {
    emits('textAlerta', e.data?.message ?? 'Erro ao salvar emblemas')
  }
}

async function getBadges() {
  const userId = store.initUser?.id
  const [res, selectedRes] = await Promise.all([
    fetch('/api/records/badges?filter=is_active,eq,1&order=id,asc&page=1,200', { credentials: 'include' }),
    userId ? fetch(`/api/records/user_badges?filter=user_id,eq,${userId}&filter=is_active,eq,1&page=1,20`, { credentials: 'include' }) : Promise.resolve(null),
  ])
  const data = await res.json()
  const selected = selectedRes ? await selectedRes.json().catch(() => ({})) : {}
  BadgeSel.value = (selected.records ?? []).map(b => b.badge_id).filter(Boolean)
  badges.value = (data.records ?? []).map(b => ({
    id:     b.id,
    image:  uploadUrl(b.image ?? ''),
  }))
}

function addBadge(i) {
  const idx = BadgeSel.value.findIndex((a) => a === i)

  if (idx >= 0) {
    BadgeSel.value.splice(idx, 1)
  } else if (BadgeSel.value.length === 6) {
    emits('textAlerta', 'Limite atingido')
  } else if (idx === -1) {
    BadgeSel.value.push(i)
  }
}

getBadges()

</script>

<style scoped>

.subModal {
  height: 246px;
}

.subModal form {
  float: left;
  width: 100%;
  z-index: 9;
  position: relative;
}

.scroll {
  position: relative;
  width: 100%;
  height: 242px;
  overflow: auto;
  z-index: 0;
}

.scroll::-webkit-scrollbar {
  width: 4px;
}

.scroll::-webkit-scrollbar-button {
  display: none;
}

.scroll::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0);
}

.scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  width: 4px;
  border-radius: 4px;
}

.scroll::-webkit-scrollbar-thumb:horizontal {
  display: none
}

.subModal .badges {
  position: relative;
  width: 100%;
  height: 190px;
}

.subModal .badge {
  float: left;
  position: relative;
  width: 54px;
  height: 54px;
  background-color: #eee;
  border-radius: 12px;
  background-position: center;
  background-repeat: no-repeat;
  margin: 8px 0 0 8px;
}

.subModal .badge.active {
  background-color: var(--color1);
  border-radius: 12px;
}
</style>
